import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles/text-display.css.js";
import withStyles from "components/with-styles";
import FormHelperText from "components/form/form-helper-text";
import Icon from "components/icon";

const TextDisplay = ({ children, classes, label, className, icon, showIfEmpty = false }) => {
  if (!children && !showIfEmpty) {
    return null;
  }

  return (
    <div className={cn(classes.displayText, className)}>
      {icon && <Icon className={classes.displayText_icon} name={icon} />}
      <FormHelperText text={label} />
      {children}
    </div>
  );
};

TextDisplay.propTypes = {
  /**
   * Icono
   **/
  icon: PropTypes.string,
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Etiqueta
   **/
  label: PropTypes.string,
  /**
   * Renderiza aunque no haya contenido
   **/
  showIfEmpty: PropTypes.bool,
};

export default withStyles(styles)(TextDisplay);
